import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { buildMenu } from './buildMenu';
import { CollapsibleGroup } from './CollapsibleGroup';
import { hasOwnMenu } from './customMenuHeads';
import type { IRecordTypeGroupsProps } from './IRecordTypeGroupsProps';
import { MenuEntryLink } from './MenuEntryLink';
import { visibleSections } from './menuEntries';
import { menuGroupsFor, PLANNING_GROUP } from './moduleSections';
import { useActiveEntryKey } from './useActiveEntryKey';
import { useMenuFacets } from './useMenuFacets';

/**
 * Групи меню головного типу запису з метаданих (`rt.menu` через buildMenu) — кожна окремою розгортною групою, типово розгорнутою:
 * пресети (у т. ч. планувальні today/created/sprint/next/unplanned — API отримує `preset=<ключ>`), фільтри, статуси й значення поля з
 * лічильниками. Подання без пресета й фільтра в лівому меню не дублюються (перемикач подань над списком, сторінки модуля). У власному меню
 * прототипу (завдання, база знань) пункт таблиці — без лічильника, а активний пункт — без жирного, як у прототипі; пункти групи «Планування»
 * — 13px (прототип tkPlan).
 */
export function RecordTypeGroups({ ws, moduleKey, moduleName, rt, planning, openState }: IRecordTypeGroupsProps) {
  const strings = useModuleStrings();
  const facets = useMenuFacets(ws, rt);
  const sections = buildMenu(menuGroupsFor(rt, planning), facets, strings, moduleName);
  const active = useActiveEntryKey(rt.key, sections);
  const own = hasOwnMenu(moduleKey);
  return (
    <>
      {visibleSections(sections).map((s) => {
        const id = `group:${rt.key}:${s.key}`;
        return (
          <CollapsibleGroup key={id} title={s.title} open={openState.isOpen(id, true)} onToggle={() => openState.toggle(id, true)}>
            {s.entries.map((e) => (
              <MenuEntryLink key={e.key} ws={ws} moduleKey={moduleKey} rtKey={rt.key} entry={e} active={e.key === active} uncounted={own && e.view === 'table'} plain={own}
                dense={s.key === PLANNING_GROUP} />
            ))}
          </CollapsibleGroup>
        );
      })}
    </>
  );
}
